export class Lesson {
  id: number;
  letters: string[] = [];
  exercises: string[] = [];
  lastAccess: string;
  bestExercise: string;
  lastExercise: number;
  introVideo: string;

  // advanced lesson fields
  advancedLessonResults: {strokes: number, errors: number, data: string, timeUsed: string}[] = [];
  wpm: number;
  accuracy: number;  
  timeUsed: string;

  // videos per exercise
  videos = new Map<number, string>();
}